import { Trans, useTranslation } from 'react-i18next'

import { FeatureFlag, useFeatureFlags } from 'src/hooks/use-feature-flags'
import { useRouting } from 'src/routes'
import { RelativeLink } from 'src/system/ui/link/RelativeLink'
import { DismissableWarning } from 'src/screens/matches/DismissableWarning'

const dismissKey = 'faceitAutoDownloadWarningDismissedAt'

// Shown on the FACEIT tab while automatic FACEIT demo downloads are
// unavailable. adhoc_free exists for exactly that period (free manual upload
// as the substitute), so the same flag turns both off when downloads are back.
export function FaceitAutoDownloadWarning() {
  const { t } = useTranslation()
  const { routes } = useRouting()
  const [enabled] = useFeatureFlags([FeatureFlag.adhocFree])

  if (!enabled) return null

  return (
    <DismissableWarning
      dismissKey={dismissKey}
      title={t('matches:faceit_auto_download_warning:title')}
      dismissLabel={t('matches:faceit_auto_download_warning:dismiss')}
    >
      <Trans i18nKey='matches:faceit_auto_download_warning:body'>
        {' '}
        <RelativeLink to={routes.account}> </RelativeLink>
      </Trans>
    </DismissableWarning>
  )
}
